import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { useTheme } from "@emotion/react";
import { Typography } from "@mui/material";

function CheckboxField({
  label,
  type,
  value,
  isRequired = false,
  isDisabled = false,
  info = "",
  onChange,
  componentId,
  categoryId,
}) {
  const theme = useTheme();
  return (
    <div
      style={{
        display: "flex",
        marginBottom: theme.size[12],
      }}
    >
      <Checkbox
        checked={value}
        disabled={isDisabled}
        onChange={() => {
          onChange(categoryId, componentId, !value);
        }}
        sx={{
          padding: "0",
          color: theme.palette.secondary.main,
          "&.Mui-checked": {
            color: theme.palette.secondary.main,
          },
          "& .MuiSvgIcon-root": {
            fontSize: theme.size[18], // Adjust the size of the icon inside the checkbox
          },
          // Disabled state styling
          "&.Mui-disabled": {
            color: theme.palette.action.disabled, // Use theme's disabled color or a custom gray
          },
          "&.Mui-disabled .MuiSvgIcon-root": {
            color: theme.palette.rapidInfra.disabledGrey, // Grays out the icon
          },
        }}
      />
      <Typography
        sx={{
          marginLeft: theme.size[4],
          fontSize: theme.size[14],
          fontWeight: theme.fontWeight[500],
          color: theme.palette.rapidInfra.text,
        }}
      >
        {label}
      </Typography>
    </div>
  );
}

export default CheckboxField;
